import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { DBCheckBoxObjective, DBTextAreaObjective, ObjectiveFlag } from '_components';
import styles from './Common.module.css'

class SpecialTestPelvicFloorAssessmentOrganProlapse extends React.Component {

    handleNoneClick(selected) {
        if (selected) {
            let fields = ['TSPELPROCYSTOCELE',
                'TSPELPRORECTOCELE',
                'TSPELPROENTEROCELE',
                'TSPELPROURETHROCELE',
                'TSPELPROUTERINE'
            ];
            this.props.clearFields(this.props.noteId, 'PTOBJECTIVESPECTESTS', 'TSNO', this.props.tsno, fields);
        }
    }

    render() {
        return (
            <div>     
                <div className={styles.checkbox_row}>
                    <ObjectiveFlag className={styles.flag} flagged={this.props.flagged} mopno={this.props.mopno} flagText='Special Test - Pelvic Floor Assessment - Organ Prolapse'/>
                    <span className={styles.spacer} />
                    <label className={styles.label}>Organ Prolapse</label>
                    <span className={styles.checkboxRow}>
                        <DBCheckBoxObjective noteId={this.props.noteId} entity='PTOBJECTIVESPECTESTS' entityKeyColumn='TSNO' entityKeyValue={this.props.tsno} field='TSPELPRONONE' label='None' className={styles.checkbox}
                            onClick={(selected) => this.handleNoneClick(selected)}
                        />
                    </span>
                </div>
                {this.props.noneSelected === false &&
                    <div>
                        <div className={styles.checkbox_row}>
                            <span className={styles.flag} />
                            <span className={styles.spacer} />
                            <span className={styles.label} />
                            <span className={styles.checkboxRow}>
                                <DBCheckBoxObjective noteId={this.props.noteId} entity='PTOBJECTIVESPECTESTS' entityKeyColumn='TSNO' entityKeyValue={this.props.tsno} field='TSPELPROCYSTOCELE' label='Cystocele' className={styles.checkbox} />
                            </span>
                        </div>
                        <div className={styles.checkbox_row}>
                            <span className={styles.flag} />
                            <span className={styles.spacer} />
                            <span className={styles.label} />
                            <span className={styles.checkboxRow}>
                                <DBCheckBoxObjective noteId={this.props.noteId} entity='PTOBJECTIVESPECTESTS' entityKeyColumn='TSNO' entityKeyValue={this.props.tsno} field='TSPELPRORECTOCELE' label='Rectocele' className={styles.checkbox} />
                            </span>
                        </div>
                        <div className={styles.checkbox_row}>
                            <span className={styles.flag} />
                            <span className={styles.spacer} />
                            <span className={styles.label} />
                            <span className={styles.checkboxRow}>
                                <DBCheckBoxObjective noteId={this.props.noteId} entity='PTOBJECTIVESPECTESTS' entityKeyColumn='TSNO' entityKeyValue={this.props.tsno} field='TSPELPROENTEROCELE' label='Enterocele' className={styles.checkbox} />
                            </span>
                        </div>
                        <div className={styles.checkbox_row}>
                            <span className={styles.flag} />
                            <span className={styles.spacer} />
                            <span className={styles.label} />
                            <span className={styles.checkboxRow}>
                                <DBCheckBoxObjective noteId={this.props.noteId} entity='PTOBJECTIVESPECTESTS' entityKeyColumn='TSNO' entityKeyValue={this.props.tsno} field='TSPELPROURETHROCELE' label='Urethrocele' className={styles.checkbox} />
                            </span>
                        </div>
                        <div className={styles.checkbox_row}>
                            <span className={styles.flag} />
                            <span className={styles.spacer} />
                            <span className={styles.label} />
                            <span className={styles.checkboxRow}>
                                <DBCheckBoxObjective noteId={this.props.noteId} entity='PTOBJECTIVESPECTESTS' entityKeyColumn='TSNO' entityKeyValue={this.props.tsno} field='TSPELPROUTERINE' label='Uterine' className={styles.checkbox} />
                            </span>
                        </div>
                    </div>
                }
                <div className={styles.textarea_row}>
                    <span className={styles.flag} />
                    <span className={styles.spacer} />
                    <label className={styles.textarea_label} >Organ Prolapse Comments</label>
                    <DBTextAreaObjective noteId={this.props.noteId} entity='PTOBJECTIVESPECTESTS' entityKeyColumn='TSNO' entityKeyValue={this.props.tsno} field='TSPELPROCOMMENTS' className={styles.comment} />
                </div>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        clearFields: bindActionCreators(noteActions.clearFields, dispatch)
    };
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let tsno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVESPECTESTS)
        .find(key => (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSNTNO === pk && noteType !== 1)));

    let flagged = false;
    if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSPELPROCYSTOCELE ||
        state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSPELPRORECTOCELE ||
        state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSPELPROENTEROCELE ||
        state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSPELPROURETHROCELE ||
        state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSPELPROUTERINE) {
        flagged = true;
    }

    return {
        noteId: noteId,
        tsno: tsno,
        flagged: flagged,
        noneSelected: state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSPELPRONONE ? state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSPELPRONONE : false
    };
}

const connectedSpecialTestPelvicFloorAssessmentOrganProlapse = connect(mapStateToProps, mapDispatchToProps)(SpecialTestPelvicFloorAssessmentOrganProlapse);
export { connectedSpecialTestPelvicFloorAssessmentOrganProlapse as SpecialTestPelvicFloorAssessmentOrganProlapse };



